import { useMedplum } from '@medplum/react';
import { PartialJwtPayload } from '../types/jwt-payload.type';
import ApiService from '@services/api-service';

// -----------------------------------------------------------------------------
const useJwtApi = (): {
  generateToken: (payload: PartialJwtPayload) => Promise<{ token: string }>;
  verifyToken: (token: string) => Promise<{
    valid: boolean;
    payload?: PartialJwtPayload;
    error?: string;
  }>;
} => {
  const medplum = useMedplum();

  // ---------------------------------------------------------------------------
  const generateToken = async (
    payload: PartialJwtPayload
  ): Promise<{ token: string }> => {
    const accessToken = medplum.getAccessToken();
    if (!accessToken) {
      throw new Error('Access token not found');
    }

    return ApiService.generateToken(payload, accessToken);
  };

  // ---------------------------------------------------------------------------
  const verifyToken = async (
    token: string
  ): Promise<{
    valid: boolean;
    payload?: PartialJwtPayload;
    error?: string;
  }> => {
    return ApiService.validateToken(token);
  };

  // ---------------------------------------------------------------------------
  return {
    generateToken,
    verifyToken,
  };
};

export { useJwtApi };
